import apiClient from './api';

const memberService = {
    // Alle Members abrufen
    getAllMembers: async () => {
        const response = await apiClient.get('/api/members');
        // Spring Data REST gibt Daten in _embedded.members zurück
        return response.data._embedded?.members || response.data;
    },

    // Member nach ID abrufen
    getMemberById: async (id) => {
        const response = await apiClient.get(`/api/members/${id}`);
        return response.data;
    },

    // Members einer Unit abrufen
    getMembersByUnit: async (unitId) => {
        const response = await apiClient.get(`/api/members/unit/${unitId}`);
        // Spring Data REST gibt Daten in _embedded.members zurück
        return response.data._embedded?.members || response.data;
    },

    // Neuen Member erstellen
    createMember: async (memberData) => {
        const response = await apiClient.post('/api/members', memberData);
        return response.data;
    },

    // Member aktualisieren
    updateMember: async (id, memberData) => {
        const response = await apiClient.put(`/api/members/${id}`, memberData);
        return response.data;
    },

    // Member löschen
    deleteMember: async (id) => {
        const response = await apiClient.delete(`/api/members/${id}`);
        return response.data;
    },
};

export default memberService;

